import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const CheckMark: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    fill="none"
    {...props}
  >
    <path
      fill="#002677"
      d="m23.623 66.677-12.188-12.19a8.891 8.891 0 0 1 0-12.573l.622-.622a8.89 8.89 0 0 1 12.574 0L36.819 53.48 23.623 66.677Z"
    />
    <path
      fill="#FF612B"
      d="M71.038 19.26 23.624 66.674 36.82 79.871l47.415-47.414c5.879-5.878 1.715-15.93-6.598-15.93a9.332 9.332 0 0 0-6.599 2.733Z"
    />
  </Box>
)
export default CheckMark
